import axios, { AxiosResponse } from 'axios';
import { Input } from './components';
import { INIT_SYNC_API_URL, INPUT_SYNC_API_URL } from './config';

export const syncInit = async (): Promise<AxiosResponse> => {
  try {
    return await axios.post(INIT_SYNC_API_URL, {
      inputState: 'INIT',
      data: [],
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};

export const onSubmitSync = async (stateName: string, inputs: Input[]): Promise<void> => {
  try {
    await axios.post(INPUT_SYNC_API_URL, {
      inputState: stateName,
      data: inputs,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};
